import axios from 'axios'

// Create axios instance
const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true
})

// Request interceptor
api.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('access_token')
    if (token !== null) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  function (error) {
    return Promise.reject(error.response)
  }
)

api.interceptors.response.use(
  response => {
    return response.data
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('access_token')
      localStorage.removeItem('selected_customer')
      localStorage.removeItem('cart')
      localStorage.removeItem('settings')
      localStorage.removeItem('user')

      window.location.replace('/auth/login')
    }

    return Promise.reject(error.response)
  }
)

export default api
